/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-self-join-visualizer block)");
/* eslint-enable no-console */

(function () {

    const DS = {
        employees: {
            table: 'employes',
            a1: 'e', a2: 'm',
            lbl1: 'Alias e (employé)', lbl2: 'Alias m (manager)',
            fkKey: 'manager_id', pkKey: 'id',
            note: 'Chaque employé avec le nom de son manager',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'nom', label: 'nom', type: 'data' },
                { key: 'poste', label: 'poste', type: 'data' },
                { key: 'manager_id', label: 'manager_id', type: 'fk' },
            ],
            rows: [
                { id: 1, nom: 'Alice', poste: 'CEO', manager_id: null },
                { id: 2, nom: 'Bob', poste: 'CTO', manager_id: 1 },
                { id: 3, nom: 'Claire', poste: 'Développeuse', manager_id: 2 },
                { id: 4, nom: 'David', poste: 'Designer', manager_id: 2 },
                { id: 5, nom: 'Emma', poste: 'Stagiaire', manager_id: 3 },
            ],
            select: [
                { a: 'e', col: 'nom', as: 'employe' },
                { a: 'e', col: 'poste', as: 'poste' },
                { a: 'm', col: 'nom', as: 'manager' },
            ],
            interp: {
                inner: 'Seuls les employés ayant un manager sont retournés. Alice (CEO) est exclue car son <code>manager_id</code> est NULL — elle est au sommet de la hiérarchie et n\'a pas de supérieur.',
                left: 'Tous les employés apparaissent, y compris Alice dont la colonne <em>manager</em> affiche NULL. Ce résultat reflète l\'organigramme complet : Alice est identifiée comme racine de la hiérarchie.',
            },
        },

        categories: {
            table: 'categories',
            a1: 'c', a2: 'p',
            lbl1: 'Alias c (sous-catégorie)', lbl2: 'Alias p (catégorie parente)',
            fkKey: 'parent_id', pkKey: 'id',
            note: 'Chaque sous-catégorie avec sa catégorie parente',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'nom', label: 'nom', type: 'data' },
                { key: 'parent_id', label: 'parent_id', type: 'fk' },
            ],
            rows: [
                { id: 1, nom: 'Informatique', parent_id: null },
                { id: 2, nom: 'Programmation', parent_id: 1 },
                { id: 3, nom: 'Bases de données', parent_id: 1 },
                { id: 4, nom: 'SQL', parent_id: 3 },
                { id: 5, nom: 'NoSQL', parent_id: 3 },
                { id: 6, nom: 'Python', parent_id: 2 },
            ],
            select: [
                { a: 'c', col: 'nom', as: 'sous_categorie' },
                { a: 'p', col: 'nom', as: 'categorie_parente' },
            ],
            interp: {
                inner: 'Seules les catégories ayant une catégorie parente sont retournées. "Informatique" est exclue car c\'est la racine de l\'arbre (<code>parent_id</code> NULL) — elle n\'appartient à aucune autre catégorie.',
                left: 'Toutes les catégories apparaissent. "Informatique" est conservée avec <em>categorie_parente</em> à NULL, ce qui indique qu\'elle est la catégorie racine du catalogue.',
            },
        },

        comments: {
            table: 'commentaires',
            a1: 'c', a2: 'p',
            lbl1: 'Alias c (commentaire)', lbl2: 'Alias p (commentaire parent)',
            fkKey: 'reponse_a', pkKey: 'id',
            note: 'Chaque réponse avec le commentaire auquel elle répond',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'auteur', label: 'auteur', type: 'data' },
                { key: 'contenu', label: 'contenu', type: 'data' },
                { key: 'reponse_a', label: 'reponse_a', type: 'fk' },
            ],
            rows: [
                { id: 1, auteur: 'Alice', contenu: 'Super article !', reponse_a: null },
                { id: 2, auteur: 'Bob', contenu: 'Merci pour ce partage.', reponse_a: null },
                { id: 3, auteur: 'Claire', contenu: 'Je suis d\'accord avec Alice.', reponse_a: 1 },
                { id: 4, auteur: 'David', contenu: 'Tu peux développer ?', reponse_a: 1 },
                { id: 5, auteur: 'Emma', contenu: 'Bonne remarque Claire.', reponse_a: 3 },
                { id: 6, auteur: 'Frank', contenu: 'Idem que Bob.', reponse_a: 2 },
            ],
            select: [
                { a: 'c', col: 'auteur', as: 'auteur' },
                { a: 'c', col: 'contenu', as: 'reponse' },
                { a: 'p', col: 'contenu', as: 'commentaire_parent' },
            ],
            interp: {
                inner: 'Seuls les commentaires qui sont des réponses à un autre commentaire apparaissent. Alice et Bob sont exclus car leurs <code>reponse_a</code> sont NULL — ce sont des commentaires racines sans parent.',
                left: 'Tous les commentaires sont listés. Alice et Bob apparaissent avec <em>commentaire_parent</em> à NULL, ce qui signifie qu\'ils ont initié un thread sans répondre à personne.',
            },
        },

        menus: {
            table: 'menus',
            a1: 'e', a2: 'p',
            lbl1: 'Alias e (entrée de menu)', lbl2: 'Alias p (menu parent)',
            fkKey: 'parent_id', pkKey: 'id',
            note: 'Chaque élément de menu avec son menu parent',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'libelle', label: 'libelle', type: 'data' },
                { key: 'url', label: 'url', type: 'data' },
                { key: 'parent_id', label: 'parent_id', type: 'fk' },
            ],
            rows: [
                { id: 1, libelle: 'Accueil', url: '/', parent_id: null },
                { id: 2, libelle: 'Tutoriels', url: '/tutos', parent_id: null },
                { id: 3, libelle: 'SQL', url: '/tutos/sql', parent_id: 2 },
                { id: 4, libelle: 'PHP', url: '/tutos/php', parent_id: 2 },
                { id: 5, libelle: 'INNER JOIN', url: '/tutos/sql/inner', parent_id: 3 },
                { id: 6, libelle: 'SELF JOIN', url: '/tutos/sql/self', parent_id: 3 },
            ],
            select: [
                { a: 'e', col: 'libelle', as: 'element' },
                { a: 'e', col: 'url', as: 'url' },
                { a: 'p', col: 'libelle', as: 'menu_parent' },
            ],
            interp: {
                inner: 'Seuls les éléments ayant un parent sont retournés. "Accueil" et "Tutoriels" sont exclus car ils sont des entrées racines du menu (<code>parent_id</code> NULL) — ils apparaissent directement dans la barre de navigation principale.',
                left: 'Tous les éléments du menu apparaissent. "Accueil" et "Tutoriels" ont <em>menu_parent</em> à NULL, ce qui confirme qu\'ils se trouvent au premier niveau de la navigation.',
            },
        },

        tasks: {
            table: 'taches',
            a1: 't', a2: 'b',
            lbl1: 'Alias t (tâche)', lbl2: 'Alias b (tâche bloquante)',
            fkKey: 'bloquee_par', pkKey: 'id',
            note: 'Chaque tâche avec la tâche dont elle dépend',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'titre', label: 'titre', type: 'data' },
                { key: 'statut', label: 'statut', type: 'data' },
                { key: 'bloquee_par', label: 'bloquee_par', type: 'fk' },
            ],
            rows: [
                { id: 1, titre: 'Initialiser le projet', statut: 'terminée', bloquee_par: null },
                { id: 2, titre: 'Créer la base de données', statut: 'terminée', bloquee_par: 1 },
                { id: 3, titre: 'Développer l\'API', statut: 'en cours', bloquee_par: 2 },
                { id: 4, titre: 'Créer l\'interface', statut: 'en attente', bloquee_par: 2 },
                { id: 5, titre: 'Rédiger les tests', statut: 'en attente', bloquee_par: 3 },
                { id: 6, titre: 'Déployer en production', statut: 'en attente', bloquee_par: 5 },
            ],
            select: [
                { a: 't', col: 'titre', as: 'tache' },
                { a: 't', col: 'statut', as: 'statut' },
                { a: 'b', col: 'titre', as: 'depend_de' },
            ],
            interp: {
                inner: 'Seules les tâches ayant une dépendance sont retournées. "Initialiser le projet" est exclue car <code>bloquee_par</code> est NULL — c\'est le point de départ du projet, sans prérequis.',
                left: 'Toutes les tâches sont listées. "Initialiser le projet" apparaît avec <em>depend_de</em> à NULL, confirmant qu\'elle peut démarrer immédiatement sans attendre une autre tâche.',
            },
        },

        regions: {
            table: 'regions',
            a1: 'r', a2: 'p',
            lbl1: 'Alias r (région)', lbl2: 'Alias p (région parente)',
            fkKey: 'parent_id', pkKey: 'id',
            note: 'Chaque région avec sa région parente',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'nom', label: 'nom', type: 'data' },
                { key: 'type', label: 'type', type: 'data' },
                { key: 'parent_id', label: 'parent_id', type: 'fk' },
            ],
            rows: [
                { id: 1, nom: 'Europe', type: 'continent', parent_id: null },
                { id: 2, nom: 'France', type: 'pays', parent_id: 1 },
                { id: 3, nom: 'Allemagne', type: 'pays', parent_id: 1 },
                { id: 4, nom: 'Grand Est', type: 'région', parent_id: 2 },
                { id: 5, nom: 'Île-de-France', type: 'région', parent_id: 2 },
                { id: 6, nom: 'Bavière', type: 'région', parent_id: 3 },
            ],
            select: [
                { a: 'r', col: 'nom', as: 'zone' },
                { a: 'r', col: 'type', as: 'type' },
                { a: 'p', col: 'nom', as: 'appartient_a' },
            ],
            interp: {
                inner: 'Seules les zones ayant une zone parente sont retournées. "Europe" est exclue car <code>parent_id</code> est NULL — c\'est le niveau racine de la hiérarchie géographique, sans continent supérieur.',
                left: 'Toutes les zones apparaissent. "Europe" est conservée avec <em>appartient_a</em> à NULL, confirmant son statut de niveau hiérarchique le plus haut dans la table.',
            },
        },

        accounts: {
            table: 'comptes',
            a1: 'a', a2: 'b',
            lbl1: 'Alias a (compte émetteur)', lbl2: 'Alias b (compte destinataire)',
            fkKey: 'vire_vers', pkKey: 'id',
            note: 'Chaque compte avec le compte destinataire du virement',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'titulaire', label: 'titulaire', type: 'data' },
                { key: 'solde', label: 'solde', type: 'data' },
                { key: 'vire_vers', label: 'vire_vers', type: 'fk' },
            ],
            rows: [
                { id: 1, titulaire: 'Alice', solde: 1200, vire_vers: 2 },
                { id: 2, titulaire: 'Bob', solde: 850, vire_vers: 3 },
                { id: 3, titulaire: 'Claire', solde: 3400, vire_vers: null },
                { id: 4, titulaire: 'David', solde: 500, vire_vers: 1 },
                { id: 5, titulaire: 'Emma', solde: 200, vire_vers: null },
            ],
            select: [
                { a: 'a', col: 'titulaire', as: 'emetteur' },
                { a: 'a', col: 'solde', as: 'solde_emetteur' },
                { a: 'b', col: 'titulaire', as: 'destinataire' },
            ],
            interp: {
                inner: 'Seuls les comptes ayant effectué un virement vers un autre compte apparaissent. Claire et Emma sont exclues car leur <code>vire_vers</code> est NULL — elles n\'ont pas de virement sortant enregistré.',
                left: 'Tous les comptes sont listés. Claire et Emma apparaissent avec <em>destinataire</em> à NULL, indiquant qu\'aucun virement sortant n\'est associé à leur compte dans la table.',
            },
        },

        products: {
            table: 'produits',
            a1: 'a', a2: 'b',
            lbl1: 'Alias a (produit)', lbl2: 'Alias b (produit de remplacement)',
            fkKey: 'remplace_par', pkKey: 'id',
            note: 'Chaque produit discontinu avec son successeur',
            cols: [
                { key: 'id', label: 'id', type: 'pk' },
                { key: 'nom', label: 'nom', type: 'data' },
                { key: 'prix', label: 'prix', type: 'data' },
                { key: 'remplace_par', label: 'remplace_par', type: 'fk' },
            ],
            rows: [
                { id: 1, nom: 'Modèle A', prix: 199, remplace_par: 3 },
                { id: 2, nom: 'Modèle B', prix: 249, remplace_par: 4 },
                { id: 3, nom: 'Modèle A Pro', prix: 299, remplace_par: null },
                { id: 4, nom: 'Modèle B Plus', prix: 349, remplace_par: null },
                { id: 5, nom: 'Modèle C', prix: 149, remplace_par: 3 },
            ],
            select: [
                { a: 'a', col: 'nom', as: 'produit_discontinu' },
                { a: 'a', col: 'prix', as: 'ancien_prix' },
                { a: 'b', col: 'nom', as: 'successeur' },
                { a: 'b', col: 'prix', as: 'nouveau_prix' },
            ],
            interp: {
                inner: 'Seuls les produits ayant un successeur sont retournés. "Modèle A Pro" et "Modèle B Plus" sont exclus car <code>remplace_par</code> est NULL — ce sont des produits actuellement en vente, sans remplacement prévu.',
                left: 'Tous les produits apparaissent. "Modèle A Pro" et "Modèle B Plus" ont <em>successeur</em> à NULL, confirmant qu\'ils sont les versions actives du catalogue et ne sont pas encore discontinués.',
            },
        },
    };

    function computeJoin(ds, type) {
        const out = [];
        for (const r1 of ds.rows) {
            const r2 = ds.rows.find(r => r1[ds.fkKey] !== null && r1[ds.fkKey] === r[ds.pkKey]) || null;
            if (r2) out.push({ r1, r2 });
            else if (type === 'left') out.push({ r1, r2: null });
        }
        return out;
    }

    function el(tag, cls) {
        const e = document.createElement(tag);
        if (cls) e.className = cls;
        return e;
    }

    function makeTd(content) {
        const c = el('td');
        if (content === null || content === undefined) {
            const s = el('span', 'sj-null'); s.textContent = 'NULL'; c.appendChild(s);
        } else {
            c.textContent = content;
        }
        return c;
    }

    /* SOURCE TABLE */
    function renderSource(ds, type) {
        const join = computeJoin(ds, type);
        const okIds = new Set(join.map(j => j.r1.id));
        const tbl = document.getElementById('sj-src-table');
        tbl.innerHTML = '';

        const thead = el('thead'), tr0 = el('tr');
        for (const col of ds.cols) {
            const th = el('th');
            if (col.type === 'fk') th.className = 'sj-col-fk';
            th.innerHTML = col.label;
            if (col.type === 'pk') th.innerHTML += ' <span class="sj-badge sj-badge-pk">PK</span>';
            if (col.type === 'fk') th.innerHTML += ' <span class="sj-badge sj-badge-fk">FK</span>';
            tr0.appendChild(th);
        }
        thead.appendChild(tr0);
        tbl.appendChild(thead);

        const tbody = el('tbody');
        for (const row of ds.rows) {
            const tr = el('tr');
            tr.className = okIds.has(row.id) ? 'sj-row-ok' : 'sj-row-out';
            for (const col of ds.cols) tr.appendChild(makeTd(row[col.key]));
            tbody.appendChild(tr);
        }
        tbl.appendChild(tbody);

        document.getElementById('sj-src-name').textContent = ds.table;
        document.getElementById('sj-src-count').textContent = ds.rows.length + ' lignes';
    }

    /* QUERY */
    function renderQuery(ds, type) {
        const kw = v => `<span class="sk">${v}</span>`;
        const al = v => `<span class="sa">${v}</span>`;
        const co = v => `<span class="sc">${v}</span>`;
        const cm = v => `<span class="scm">${v}</span>`;
        const jk = type === 'inner' ? 'INNER JOIN' : 'LEFT JOIN';

        const sel = ds.select.map(c => `  ${al(c.a)}.${co(c.col)} ${kw('AS')} ${co(c.as)}`).join(',\n');

        document.getElementById('sj-query').innerHTML =
            `${cm('-- ' + ds.note)}\n` +
            `${kw('SELECT')}\n${sel}\n` +
            `${kw('FROM')} ${ds.table} ${al(ds.a1)}\n` +
            `${kw(jk)} ${ds.table} ${al(ds.a2)}\n` +
            `  ${kw('ON')} ${al(ds.a1)}.${co(ds.fkKey)} = ${al(ds.a2)}.${co(ds.pkKey)};`;
    }

    /* RESULT */
    function renderResult(ds, type) {
        const join = computeJoin(ds, type);
        const tbl = document.getElementById('sj-res-table');
        tbl.innerHTML = '';

        document.getElementById('sj-res-count').textContent = join.length + ' ligne' + (join.length > 1 ? 's' : '');

        const t1cols = ds.select.filter(c => c.a === ds.a1).map(c => c.as);
        const thead = el('thead'), tr0 = el('tr');
        ds.select.forEach(c => {
            const th = el('th');
            th.className = t1cols.includes(c.as) ? 'sj-t1h' : 'sj-t2h';
            th.textContent = c.as;
            tr0.appendChild(th);
        });
        thead.appendChild(tr0);
        tbl.appendChild(thead);

        const tbody = el('tbody');
        join.forEach(({ r1, r2 }) => {
            const tr = el('tr');
            ds.select.forEach(c => {
                const src = c.a === ds.a1 ? r1 : r2;
                tr.appendChild(makeTd(src ? src[c.col] : null));
            });
            tbody.appendChild(tr);
        });
        tbl.appendChild(tbody);
    }

    /* INTERPRETATION */
    function renderInterp(ds, type) {
        const box = document.getElementById('sj-interp');
        if (box) box.innerHTML = ds.interp[type];
    }

    /* PAIRS */
    function renderPairs(ds, type) {
        const join = computeJoin(ds, type);
        const matched = join.filter(j => j.r2 !== null);
        const cont = document.getElementById('sj-pairs');
        cont.innerHTML = '';

        document.getElementById('sj-pairs-count').textContent = matched.length + ' paire' + (matched.length > 1 ? 's' : '');

        if (!matched.length) {
            const d = el('div', 'sj-empty'); d.textContent = 'Aucune correspondance.'; cont.appendChild(d); return;
        }

        matched.forEach(({ r1, r2 }) => {
            const pair = el('div', 'sj-pair');

            const makeSide = (row, cls, lbl) => {
                const side = el('div', 'sj-pair-side ' + cls);
                const tag = el('div', 'sj-pair-label'); tag.textContent = lbl;
                side.appendChild(tag);
                const rowEl = el('div', 'sj-pair-row');
                ds.cols.forEach(col => {
                    const kv = el('span', 'sj-kv');
                    kv.innerHTML = col.label + ': ';
                    const v = row[col.key];
                    if (v === null) { const s = el('span', 'sj-null'); s.textContent = 'NULL'; kv.appendChild(s); }
                    else { const b = el('b'); b.textContent = v; kv.appendChild(b); }
                    rowEl.appendChild(kv);
                });
                side.appendChild(rowEl);
                return side;
            };

            pair.appendChild(makeSide(r1, 'p1', ds.lbl1));
            const arr = el('div', 'sj-pair-arrow'); arr.textContent = '↔'; pair.appendChild(arr);
            pair.appendChild(makeSide(r2, 'p2', ds.lbl2));
            cont.appendChild(pair);
        });
    }

    /* MAIN */
    function sjRender() {
        const ds = DS[document.getElementById('sj-dataset').value];
        const type = document.getElementById('sj-jointype').value;
        renderSource(ds, type);
        renderQuery(ds, type);
        renderResult(ds, type);
        renderInterp(ds, type);
        renderPairs(ds, type);
    }

    function sjToggle(id) {
        const e = document.getElementById(id);
        if (e) e.style.display = e.style.display === 'none' ? '' : 'none';
    }

    document.getElementById('sj-dataset').addEventListener('change', sjRender);
    document.getElementById('sj-jointype').addEventListener('change', sjRender);
    document.getElementById('chk-source').addEventListener('change', function () { sjToggle('sec-source'); });
    document.getElementById('chk-query').addEventListener('change', function () { sjToggle('sec-query'); });
    document.getElementById('chk-result').addEventListener('change', function () { sjToggle('sec-result'); });
    document.getElementById('chk-pairs').addEventListener('change', function () { sjToggle('sec-pairs'); });

    sjRender();

})();